import React, { Component } from "react";
import { Text, HStack, VStack, Center } from '@chakra-ui/react'

import CardUtils from "../Models/CardUtils";





export default class CompositeCountDisplay extends Component 
{
    constructor(props)
    {
        super(props);
    }


  





    render() 
    {

        var containerCountTitle = this.props.card.containerCountTitle;
        var containerQtyTitle = this.props.card.containerQtyTitle;
        var unitQtyTitle = this.props.card.unitQtyTitle;
        

        var containerCount = this.props.valueBag[CardUtils.titleToId(this.props.card.containerCountTitle)];
        var containerQty = this.props.valueBag[CardUtils.titleToId(this.props.card.containerQtyTitle)];
        var unitQty = this.props.valueBag[CardUtils.titleToId(this.props.card.unitQtyTitle)];


        return(    
            
        
            <Center>
            <HStack>
                <VStack>
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="white" margin='0'>{containerCountTitle}</Text> 
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="white" margin='0'>{containerCount}</Text>
                </VStack>

                <VStack>
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="white" margin='0'>{containerQtyTitle}</Text> 
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="white" margin='0'>{containerQty}</Text> 
                </VStack>

                <VStack>
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="white" margin='0'>{unitQtyTitle}</Text> 
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="white" margin='0'>{unitQty}</Text> 
                </VStack>
     

            </HStack>
            </Center>





        )
    }
}







